import { render, staticRenderFns } from "./FlightDashBoard.vue?vue&type=template&id=cb05afde&scoped=true&"
import script from "./FlightDashBoard.vue?vue&type=script&lang=js&"
export * from "./FlightDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./FlightDashBoard.vue?vue&type=style&index=0&id=cb05afde&scoped=true&lang=css&"
import style1 from "./FlightDashBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb05afde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VMenu,VSelect,VTextField})
